module.exports = __webpack_public_path__ + "img/wallet.5c938044.png";